import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import SplitText from 'gsap/SplitText'
import CustomEase from 'gsap/CustomEase'
import Lenis from 'lenis'

gsap.registerPlugin(ScrollTrigger, SplitText, CustomEase)

export default class Scroll {
    constructor(){
        this.screenPosition = 0
        
        this.init()
        this.initScrollTo()
    }

    init() {
        this.lenis = new Lenis({
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            orientation: 'vertical',
            gestureOrientation: 'vertical',
            smoothWheel: true,
            wheelMultiplier: 1,
            smoothTouch: false,
            touchMultiplier: 2,
            infinite: false,
        })

        this.lenis.on('scroll', ({ scroll }) => {
            this.screenPosition = scroll
            ScrollTrigger.update()
        })

        const raf = (time) => {
            this.lenis.raf(time)
            requestAnimationFrame(raf)
        }
        requestAnimationFrame(raf)

        // Refresh ScrollTrigger on resize
        window.addEventListener('resize', () => {
            ScrollTrigger.refresh()
        })
    }

    initScrollTo() {
        const scrollToElements = document.querySelectorAll('[data-scroll-to]')
        
        scrollToElements.forEach(element => {
            element.addEventListener('click', (e) => {
                e.preventDefault()
                
                const target = element.getAttribute('data-scroll-to')
                const offset = element.getAttribute('data-scroll-offset')
                const duration = element.getAttribute('data-scroll-duration')
                
                if (target) {
                    const options = {}
                    if (offset) options.offset = parseInt(offset)
                    if (duration) options.duration = parseFloat(duration)
                    
                    this.scrollTo(target, options)
                }
            })
        })
    }

    stop() {
        this.lenis.stop()
    }

    start() {
        this.lenis.start()
    }

    scrollTo(target, options = {}) {
        const defaultOptions = {
            offset: 0,
            duration: 1,
            easing: (t) => t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
        }
        
        this.lenis.scrollTo(target, { ...defaultOptions, ...options })
    }
}

const splitConfig = {
  lines: { duration: 0.8, stagger: 0.08 },
  words: { duration: 0.6, stagger: 0.06 },
  chars: { duration: 0.4, stagger: 0.01 }
}

function initMaskTextScrollReveal() {
    document.querySelectorAll('[data-split="heading"]').forEach(heading => {
        // Simple fadeInUp animation without SplitText
        gsap.from(heading, {
            opacity: 0,
            y: 40,
            duration: 0.8,
            ease: CustomEase.create("out", "0.125, 0.425, 0.270, 1.000"),
            scrollTrigger: {
                trigger: heading,
                start: 'clamp(top 100%)',
                once: true
            }
        })
    })
}

function initParallax() {
    document.querySelectorAll('[data-parallax]').forEach(element => {
        const speed = parseFloat(element.dataset.parallax) || 0.2
        const direction = element.dataset.parallaxDirection || 'down'
        
        const distance = element.offsetHeight * speed
        
        gsap.to(element, {
            y: direction === 'down' ? distance : -distance,
            ease: 'none',
            scrollTrigger: {
                trigger: element,
                start: 'top bottom',
                end: 'bottom top',
                scrub: 1.2,
                invalidateOnRefresh: true
            }
        })
    })
}

document.addEventListener("DOMContentLoaded", () => {
    initMaskTextScrollReveal()
    initParallax()
});